/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal.js";
import { ChainConfig } from "./chain_config.js";
export const protobufPackage = "injective.evm.v1";
function createBaseTraceConfig() {
    return {
        tracer: "",
        timeout: "",
        reexec: "0",
        disableStack: false,
        disableStorage: false,
        debug: false,
        limit: 0,
        overrides: undefined,
        enableMemory: false,
        enableReturnData: false,
        tracerJsonConfig: "",
        stateOverrides: new Uint8Array(),
        blockOverrides: new Uint8Array(),
    };
}
export const TraceConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.tracer !== "") {
            writer.uint32(10).string(message.tracer);
        }
        if (message.timeout !== "") {
            writer.uint32(18).string(message.timeout);
        }
        if (message.reexec !== "0") {
            writer.uint32(24).uint64(message.reexec);
        }
        if (message.disableStack === true) {
            writer.uint32(40).bool(message.disableStack);
        }
        if (message.disableStorage === true) {
            writer.uint32(48).bool(message.disableStorage);
        }
        if (message.debug === true) {
            writer.uint32(64).bool(message.debug);
        }
        if (message.limit !== 0) {
            writer.uint32(72).int32(message.limit);
        }
        if (message.overrides !== undefined) {
            ChainConfig.encode(message.overrides, writer.uint32(82).fork()).ldelim();
        }
        if (message.enableMemory === true) {
            writer.uint32(88).bool(message.enableMemory);
        }
        if (message.enableReturnData === true) {
            writer.uint32(96).bool(message.enableReturnData);
        }
        if (message.tracerJsonConfig !== "") {
            writer.uint32(106).string(message.tracerJsonConfig);
        }
        if (message.stateOverrides.length !== 0) {
            writer.uint32(114).bytes(message.stateOverrides);
        }
        if (message.blockOverrides.length !== 0) {
            writer.uint32(122).bytes(message.blockOverrides);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTraceConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tracer = reader.string();
                    break;
                case 2:
                    message.timeout = reader.string();
                    break;
                case 3:
                    message.reexec = longToString(reader.uint64());
                    break;
                case 5:
                    message.disableStack = reader.bool();
                    break;
                case 6:
                    message.disableStorage = reader.bool();
                    break;
                case 8:
                    message.debug = reader.bool();
                    break;
                case 9:
                    message.limit = reader.int32();
                    break;
                case 10:
                    message.overrides = ChainConfig.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.enableMemory = reader.bool();
                    break;
                case 12:
                    message.enableReturnData = reader.bool();
                    break;
                case 13:
                    message.tracerJsonConfig = reader.string();
                    break;
                case 14:
                    message.stateOverrides = reader.bytes();
                    break;
                case 15:
                    message.blockOverrides = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            tracer: isSet(object.tracer) ? String(object.tracer) : "",
            timeout: isSet(object.timeout) ? String(object.timeout) : "",
            reexec: isSet(object.reexec) ? String(object.reexec) : "0",
            disableStack: isSet(object.disableStack) ? Boolean(object.disableStack) : false,
            disableStorage: isSet(object.disableStorage) ? Boolean(object.disableStorage) : false,
            debug: isSet(object.debug) ? Boolean(object.debug) : false,
            limit: isSet(object.limit) ? Number(object.limit) : 0,
            overrides: isSet(object.overrides) ? ChainConfig.fromJSON(object.overrides) : undefined,
            enableMemory: isSet(object.enableMemory) ? Boolean(object.enableMemory) : false,
            enableReturnData: isSet(object.enableReturnData) ? Boolean(object.enableReturnData) : false,
            tracerJsonConfig: isSet(object.tracerJsonConfig) ? String(object.tracerJsonConfig) : "",
            stateOverrides: isSet(object.stateOverrides) ? bytesFromBase64(object.stateOverrides) : new Uint8Array(),
            blockOverrides: isSet(object.blockOverrides) ? bytesFromBase64(object.blockOverrides) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.tracer !== undefined && (obj.tracer = message.tracer);
        message.timeout !== undefined && (obj.timeout = message.timeout);
        message.reexec !== undefined && (obj.reexec = message.reexec);
        message.disableStack !== undefined && (obj.disableStack = message.disableStack);
        message.disableStorage !== undefined && (obj.disableStorage = message.disableStorage);
        message.debug !== undefined && (obj.debug = message.debug);
        message.limit !== undefined && (obj.limit = Math.round(message.limit));
        message.overrides !== undefined &&
            (obj.overrides = message.overrides ? ChainConfig.toJSON(message.overrides) : undefined);
        message.enableMemory !== undefined && (obj.enableMemory = message.enableMemory);
        message.enableReturnData !== undefined && (obj.enableReturnData = message.enableReturnData);
        message.tracerJsonConfig !== undefined && (obj.tracerJsonConfig = message.tracerJsonConfig);
        message.stateOverrides !== undefined &&
            (obj.stateOverrides = base64FromBytes(message.stateOverrides !== undefined ? message.stateOverrides : new Uint8Array()));
        message.blockOverrides !== undefined &&
            (obj.blockOverrides = base64FromBytes(message.blockOverrides !== undefined ? message.blockOverrides : new Uint8Array()));
        return obj;
    },
    create(base) {
        return TraceConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTraceConfig();
        message.tracer = object.tracer ?? "";
        message.timeout = object.timeout ?? "";
        message.reexec = object.reexec ?? "0";
        message.disableStack = object.disableStack ?? false;
        message.disableStorage = object.disableStorage ?? false;
        message.debug = object.debug ?? false;
        message.limit = object.limit ?? 0;
        message.overrides = (object.overrides !== undefined && object.overrides !== null)
            ? ChainConfig.fromPartial(object.overrides)
            : undefined;
        message.enableMemory = object.enableMemory ?? false;
        message.enableReturnData = object.enableReturnData ?? false;
        message.tracerJsonConfig = object.tracerJsonConfig ?? "";
        message.stateOverrides = object.stateOverrides ?? new Uint8Array();
        message.blockOverrides = object.blockOverrides ?? new Uint8Array();
        return message;
    },
};
var tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (tsProtoGlobalThis.Buffer) {
        return Uint8Array.from(tsProtoGlobalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = tsProtoGlobalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (tsProtoGlobalThis.Buffer) {
        return tsProtoGlobalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return tsProtoGlobalThis.btoa(bin.join(""));
    }
}
function longToString(long) {
    return long.toString();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
